<template>
  <div class="g-maps-wrapper"></div>
</template>

<script>
import gmapsInit from '@/plugins/gmaps';
import circleIcon from "@/assets/map-circle-point.png";

export default {
  name: 'MainMap',
  props: {
    markers: Array,
    mapPositionCoordinates: Object,
    selectedMarker: Object,
    displayPath: Boolean,
    circles: Array
  },
  data: () => ({
    map: null,
    markerElements: {},
    circleElements: {},
    bounds: null,
    infoWindow: null,
    zoomLevel: 20,
    polyLine: null,
    polyLineList: [],
    markerPath: [],
    circleMarkerElements: {}
  }),
  async mounted() {
    try {
      const context = this;
      const google = await gmapsInit();
      this.bounds = new google.maps.LatLngBounds();
      this.infoWindow = new google.maps.InfoWindow();

      this.infoWindow.addListener('closeclick', () => {
        this.$emit('onMarkerClicked', null);
      });
      
      let center;

      if(this.markers && this.markers.length) {
        center = {lat: this.markers[0].position.lat, lng: this.markers[0].position.lng};
      } else if(this.circles && this.circles.length) {
        center = {lat: this.circles[0].position.lat, lng: this.circles[0].position.lng};
      }

      this.map = new google.maps.Map(this.$el, {
        center: center,
        // mapTypeControlOptions: {
        //   mapTypeIds: [google.maps.MapTypeId.ROADMAP]
        // },
        // disableDefaultUI: true,
        // mapTypeControl: false,
        scaleControl: true,
        streetViewControl: false,
        zoomControl: true,
        zoomControlOptions: {
          style: google.maps.ZoomControlStyle.LARGE 
        },
        fullscreenControl: true,
        mapTypeId: google.maps.MapTypeId.ROADMAP
      });

      this.generateMarkers(this.markers);

      if(this.circles && this.circles.length) {
        this.generateCircles(this.circles);
      }
      
      if(this.displayPath) {
        this.polyLine = new google.maps.Polyline({
          path: this.markerPath,
          strokeColor: "#FF0000",
          strokeOpacity: 0.4,
          strokeWeight: 5,
          map: this.map
        })

        this.polyLineList.push(this.polyLine);
      }

      // This is needed to set the zoom after fitbounds, 
      var zoomChangeBoundsListener = google.maps.event.addListener(this.map, 'bounds_changed', function(event) {
        google.maps.event.removeListener(zoomChangeBoundsListener);
        this.setZoom( Math.min(context.zoomLevel, this.getZoom() ) );
      });

      this.map.fitBounds(this.bounds);

    } catch (error) {
      throw error;
    }
  },
  methods: {
    generateMarkers(markers) {
      this.markerPath = [];

      markers.forEach((marker, index) => {
        let displayLastLocation = markers.length - 1 === index && this.displayPath;
        let markerIconUrl;
        
        if(this.displayPath) {
          markerIconUrl = displayLastLocation ? "https://maps.gstatic.com/mapfiles/ms2/micons/green-dot.png" : circleIcon;
        } else {
          displayLastLocation = true;
          markerIconUrl = "https://maps.gstatic.com/mapfiles/ms2/micons/green-dot.png";
        }
        
        
        const zIndex = index + 1;

        const markerEl = new google.maps.Marker({
          map: this.map,
          animation: google.maps.Animation.DROP,
          position: marker.position,
          title: marker.title,
          icon: {
            url: markerIconUrl,
            size: displayLastLocation ? new google.maps.Size(32, 32) : new google.maps.Size(15, 15),
            origin: new google.maps.Point(0, 0),
            anchor: displayLastLocation ? new google.maps.Point(15, 32) : new google.maps.Point(7, 7)
          },
          zIndex
        });

        if(this.displayPath) {
          this.markerPath.push(new google.maps.LatLng(marker.position.lat, marker.position.lng));
        }

        this.bounds.extend(marker.position);

        markerEl.addListener('click', () => { 
          this.$emit('onMarkerClicked', marker);
          this.infoWindow.setContent(`<h4>${marker.title}</h4><p>${marker.info}</p>`);
          this.infoWindow.open(this.map, markerEl);
        });

        this.markerElements[marker.id] = markerEl;
      })
    },
    generateCircles(circles) {
      circles.forEach(circle => {
        const newCircle = new google.maps.Circle({
          strokeColor: '#FF0000',
          strokeOpacity: 0.8,
          strokeWeight: 2,
          fillColor: '#FF0000',
          fillOpacity: 0.35,
          map: this.map,
          radius: circle.radius,
          center: circle.position,
        });

        const circleMarker = new google.maps.Marker({
          map: this.map,
          animation: google.maps.Animation.DROP,
          position: circle.position,
          icon: {
            url: circle.type === 'origin' ? 'https://maps.gstatic.com/mapfiles/ms2/micons/rangerstation.png' : 'https://maps.gstatic.com/mapfiles/ms2/micons/realestate.png',
            size: new google.maps.Size(32, 32),
            origin: new google.maps.Point(0, 0),
            anchor: new google.maps.Point(15, 32)
          },
        });

        this.bounds.extend(circle.position);

        this.circleElements[circle.id] = newCircle;
        this.circleMarkerElements[circle.id] = circleMarker;
      })
    }
  },
  watch: {
    markers(newValues) {
      const context = this;
      this.bounds = new google.maps.LatLngBounds(); // reset bounds

      for(let markerId in this.markerElements) {
        this.markerElements[markerId].setMap(null);
      }

      for(let polyLineId in this.polyLineList) {
        this.polyLineList[polyLineId].setMap(null);
      }

      this.markerElements = {}; // reset array of marker elements
      this.polyLineList = []; // reset list of lines

      this.generateMarkers(newValues); // regenerate markers

      if(this.displayPath) {
        this.polyLine = new google.maps.Polyline({
          path: this.markerPath,
          strokeColor: "#FF0000",
          strokeOpacity: 0.4,
          strokeWeight: 5,
          map: this.map
        })

        this.polyLineList.push(this.polyLine);
      }
      
      // This is needed to set the zoom after fitbounds, 
      var zoomChangeBoundsListener = google.maps.event.addListener(this.map, 'bounds_changed', function(event) {
        google.maps.event.removeListener(zoomChangeBoundsListener);
        this.setZoom( Math.min(context.zoomLevel, this.getZoom() ) );
      });

      this.map.fitBounds(this.bounds);
    },
    selectedMarker(newValue) {
      if(newValue) {
        this.map.setCenter(newValue.position);
        new google.maps.event.trigger(this.markerElements[newValue.id], 'click'); // trigger click on marker after selectedMarker is updated from the table
      }
    },
    circles (newValue) {
      for(let circleId in this.circleElements) {
        this.circleElements[circleId].setMap(null);
        this.circleMarkerElements[circleId].setMap(null);
      }

      this.circleElements = {};
      this.circleMarkerElements = {};

      if(newValue && newValue.length && window.google) {
        this.generateCircles(newValue);
        this.map.fitBounds(this.bounds);
      }
    }
  }
}
</script>

<style lang="scss" scoped>
  .g-maps-wrapper {
    width: 100%;
    height: calc(100vh - 200px);
    min-height: 500px;
  }
</style>